import React, { useState } from 'react';
import { differenceInMinutes } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { BackgroundImage, ChannelImage, StyledLink, Title } from './LivestreamTeaser.styles';
import { centralEuropeanNow, utcToCentralEuropean } from '../../../../../play-core/utils/date-helper';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useUdpSectionTracking } from '../../../analytics/use-udp-section-tracking';
import { usePath } from '../../../config/VideoAppContext';
import { AssetImage } from '../../Image/AssetImage';
import { DensityAwareImage } from '../../Image/DensityAwareImage';
import { useSectionMeta } from '../../Section/SectionMetaProvider';
import { VideoProgress, ProgressContainer } from '../TeaserActions/VideoProgress';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LivestreamTeaser = ({
  livestreamNowAndNext,
  index
}) => {
  const {
    t
  } = useTranslation();
  const {
    livePath
  } = usePath();
  const {
    now,
    title,
    id,
    channelId
  } = livestreamNowAndNext;
  const [isHovering, setHover] = useState(false);
  const [isFocused, setFocus] = useState(false);
  const analytics = useAnalyticsDispatch();
  const sectionMeta = useSectionMeta();
  const {
    sectionId,
    representationName,
    sectionTitle
  } = sectionMeta;
  const backgroundStyle = isHovering || isFocused ? {
    opacity: 0.4
  } : {
    opacity: 0.3
  };
  const getProgress = () => {
    if (now?.startTime && now.endTime) {
      const currentTime = centralEuropeanNow();
      const startTime = utcToCentralEuropean(now.startTime);
      const endTime = utcToCentralEuropean(now.endTime);
      const durationInMinutes = differenceInMinutes(endTime, startTime);
      const runtimeInMinutes = differenceInMinutes(currentTime, startTime);
      const progress = 100 / durationInMinutes * runtimeInMinutes;
      return progress;
    }
  };
  const progress = getProgress();
  const ImageType = now?.imageUrl ? DensityAwareImage : AssetImage;
  const channelImage = livestreamNowAndNext.imageUrlRaw || livestreamNowAndNext.imageUrl;
  const backgroundImage = now?.imageUrl || channelImage;
  const trackSection = useUdpSectionTracking();
  return /*#__PURE__*/_jsxs(StyledLink, {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    to: livePath({
      id,
      title
    }),
    "aria-label": `${title} - ${t('global.live')} - ${now?.title ?? ''}`,
    onClick: () => {
      if (sectionId || representationName) {
        analytics({
          type: 'click-event',
          name: 'TvLivestramClick',
          value1: channelId,
          value2: sectionId,
          value3: sectionTitle,
          value4: representationName
        });
        trackSection({
          sectionMeta,
          item: {
            urn: livestreamNowAndNext.livestreamUrn,
            index
          }
        });
      }
    },
    children: [channelImage && /*#__PURE__*/_jsx(ChannelImage, {
      alt: title,
      src: channelImage
    }), /*#__PURE__*/_jsx(Title, {
      "aria-hidden": "true",
      children: now?.title
    }), !!progress && /*#__PURE__*/_jsx(ProgressContainer, {
      children: /*#__PURE__*/_jsx(VideoProgress, {
        percentage: progress
      })
    }), /*#__PURE__*/_jsx(BackgroundImage, {
      style: backgroundStyle,
      children: backgroundImage && /*#__PURE__*/_jsx(ImageType, {
        src: backgroundImage,
        alt: now?.title || title,
        width: 320
      })
    })]
  });
};